module.exports = __webpack_public_path__ + "assets/img/logo-new.8058ad08.png";